import { useEffect, useState } from "react";
import Api from "../../../../services/Api";
import Functions from "../../../../services/Functions";
import SmallPieGraph from "../../../general/SmallPieGraph";
import styles from "./GeneralConditionL1.module.css";
import { GeneralConditionStore } from "./GeneralConditionStore";

function GeneralConditionL1({ distrito, menuFilterParams, searchControl }) {
  const [carroProprio, setCarroProprio] = useState(null);
  const [energiaEletrica, setEnergiaEletrica] = useState(null);
  const [abastecimentoAgua, setAbastecimentoAgua] = useState(null);
  const [carroProprioOldValue, setCarroProprioOldValue] = useState(null);
  const [energiaEletricaOldValue, setEnergiaEletricaOldValue] = useState(null);
  const [abastecimentoAguaOldValue, setAbastecimentoAguaOldValue] =
    useState(null);
  const [loading, setLoading] = useState(true);

  const setCarroImage = GeneralConditionStore((state) => state.setCarroImage);
  const setEnergiaImage = GeneralConditionStore(
    (state) => state.setEnergiaImage
  );
  const setAguaImage = GeneralConditionStore((state) => state.setAguaImage);

  const setCarroValue = GeneralConditionStore((state) => state.setCarroValue);
  const setEnergiaValue = GeneralConditionStore(
    (state) => state.setEnergiaValue
  );
  const setAguaValue = GeneralConditionStore((state) => state.setAguaValue);

  const aguaValue = GeneralConditionStore((state) => state.aguaValue);
  const energiaValue = GeneralConditionStore((state) => state.energiaValue);
  const carroValue = GeneralConditionStore((state) => state.carroValue);

  const fossaValue = GeneralConditionStore((state) => state.fossaValue);
  const lixoValue = GeneralConditionStore((state) => state.lixoValue);
  const esgotoValue = GeneralConditionStore((state) => state.esgotoValue);

  const { selectedOption, searchInput } = searchControl;
  const { category, subcategoria, natureza } = menuFilterParams;

  const inscricao = Functions.getInscricaoParam(selectedOption, searchInput);
  const proprietario = Functions.getProprietarioParam(
    selectedOption,
    searchInput
  );

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const [carro, energia, agua] = await Promise.all([
          Api.getPossuiCarro(
            distrito,
            category,
            subcategoria,
            natureza,
            inscricao,
            proprietario,
            energiaValue,
            aguaValue,
            fossaValue,
            lixoValue,
            esgotoValue
          ),
          Api.getEnergiaEletrica(
            distrito,
            category,
            subcategoria,
            natureza,
            inscricao,
            proprietario,
            carroValue,
            aguaValue,
            fossaValue,
            lixoValue,
            esgotoValue
          ),
          Api.getAbastecimentoAgua(
            distrito,
            category,
            subcategoria,
            natureza,
            inscricao,
            proprietario,
            carroValue,
            energiaValue,
            fossaValue,
            lixoValue,
            esgotoValue
          ),
        ]);
        setCarroProprio(Functions.buildSmallPieGraphParams(carro));
        setEnergiaEletrica(Functions.buildSmallPieGraphParams(energia));
        setAbastecimentoAgua(Functions.buildSmallPieGraphParams(agua));
      } catch (error) {
        console.error("Erro ao buscar dados:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [
    distrito,
    category,
    subcategoria,
    natureza,
    inscricao,
    proprietario,
    carroValue,
    energiaValue,
    aguaValue,
    fossaValue,
    lixoValue,
    esgotoValue,
  ]);

  if (loading) return <div className={styles.generalConditionL1}></div>;

  const onEnergiaEletricaClick = (value) => {
    setEnergiaValue(value);
  };

  const onPossuiCarroClick = (value) => {
    setCarroValue(value);
  };

  const onAbastecimentoAguaClick = (value) => {
    setAguaValue(value);
  };

  const onEnergiaEletricaOldValue = (value) => {
    setEnergiaEletricaOldValue(value);
  };

  const onPossuiCarroOldValue = (value) => {
    setCarroProprioOldValue(value);
  };

  const onAbastecimentoAguaOldValue = (value) => {
    setAbastecimentoAguaOldValue(value);
  };

  return (
    <div className={styles.generalConditionL1}>
      {carroProprio && (
        <div className={styles.smallPiegraph}>
          <SmallPieGraph
            data={carroProprio}
            text="POSSUI CARRO PRÓPRIO"
            onLegendClick={onPossuiCarroClick}
            currentValue={carroValue}
            oldValue={carroProprioOldValue}
            onOldValue={onPossuiCarroOldValue}
            onImageReady={setCarroImage}
          />
        </div>
      )}

      {energiaEletrica && (
        <div className={styles.smallPiegraph}>
          <SmallPieGraph
            data={energiaEletrica}
            text="ENERGIA ELÉTRICA"
            onLegendClick={onEnergiaEletricaClick}
            currentValue={energiaValue}
            oldValue={energiaEletricaOldValue}
            onOldValue={onEnergiaEletricaOldValue}
            onImageReady={setEnergiaImage}
          />
        </div>
      )}

      {abastecimentoAgua && (
        <div className={styles.smallPiegraph}>
          <SmallPieGraph
            data={abastecimentoAgua}
            text="ABASTECIMENTO DE ÁGUA"
            onLegendClick={onAbastecimentoAguaClick}
            currentValue={aguaValue}
            oldValue={abastecimentoAguaOldValue}
            onOldValue={onAbastecimentoAguaOldValue}
            onImageReady={setAguaImage}
          />
        </div>
      )}
    </div>
  );
}

export default GeneralConditionL1;
